import { PURGE } from 'redux-persist'
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  LOGOUT_USER,
  SET_USER
} from '../actions'

const INIT_STATE = {
  token: localStorage.getItem('user-token'),
  loading: false,
  user: null
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true }
    case SET_USER:
      return { ...state, user: { ...state.user, ...action.payload } }
    case LOGIN_USER_SUCCESS:
      return { ...state, loading: false, token: action.payload }
    case REGISTER_USER:
      return { ...state, loading: true }
    case REGISTER_USER_SUCCESS:
      return { ...state, loading: false, token: action.payload }
    case LOGOUT_USER:
      return { ...state, token: null }
    case PURGE:
      return INIT_STATE
    default:
      return state
  }
}
